// GENERATED FILE - DO NOT MODIFY

export enum GetArticlesSortColumnDto {
    TitleEn = "TitleEn",
    TitleFr = "TitleFr",
    Date = "Date",
}